module.exports = __webpack_public_path__ + "static/media/wipeout.81cc3ace.png";